import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';
import { map } from 'rxjs/operators';

@Injectable()
export class HeaderService {

  private URL = AppSettings.API_ENDPOINT;
  private URL3= AppSettings.API_ENDPOINT_V3

  constructor(private http: HttpClient) {
  }

  schoolInfo(schoolId, authToken) {
    const params = { schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.post(this.URL + '/settings/schoolDetails', params, { headers }).pipe(map(res => res));
  }

  isValidToken(authToken) {
    const params = {};
    const headers = new HttpHeaders().append('authToken', authToken)
    return this.http.post(this.URL + '/login/findlogin', params, { headers }).pipe(map(res => res));
  }

  getIdCardTemplate(){
    const authToken = localStorage.getItem('usertoken');
    const headers = new HttpHeaders().append('token', authToken);
    const lang = "en";
  return this.http.get(this.URL3 + `/get/id/card/template/list?lang=${lang}`, { headers }).pipe(map(res => res));
  }

  getStaffIdCardTemplate(){
    const authToken = localStorage.getItem('usertoken');
    const headers = new HttpHeaders().append('token', authToken);
    const lang = "en";
  return this.http.get(this.URL3 + `/get/id/card/template/list/for/staff?lang=${lang}`, { headers }).pipe(map(res => res));
  }

  generateIdCard(body){
    const authToken = localStorage.getItem('usertoken');
    const headers = new HttpHeaders().append('token', authToken);
    const lang = "en";
  return this.http.post(this.URL3 + "/generate/id/card/for/group/of/students",body, { headers }).pipe(map(res => res));
  }

  generateStaffIdCard(body){
    const authToken = localStorage.getItem('usertoken');
    const headers = new HttpHeaders().append('token', authToken);
    const lang = "en";
  return this.http.post(this.URL3 + "/generate/id/card/for/group/of/staffs",body, { headers }).pipe(map(res => res));
  }

  isValidSchoolId(schoolId) {
    const params = { schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/login/findSchool', params, { headers }).pipe(map(res => res));
  }

  getClassConfigStatus(overAll, authToken) {
    const params = { overAll };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.post(this.URL + '/classManagement/classmanagement/configStatus', params, { headers }).pipe(map(res => res));
  }

  getStudentIdCardDetails(studentId, academicId, authToken) {
    const params = { studentId, academicId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.post(this.URL + '/studentlist/studentidcarddetails', params, { headers }).pipe(map(res => res));
  }

  alreadyPaidInvoice(authToken) {
    const params = {};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.post(this.URL + '/signUp/alreadyPaidInvoice', params, { headers }).pipe(map(res => res));
  }

  generateTcForStudent(studentList,academicId){
    const params = {lang : "en",studentIdList :studentList,academicId : academicId}
    // console.log("ass",param);
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('token', localStorage.getItem('usertoken'))
    return  this.http.post(this.URL3 + '/generate/tc/for/group/of/students', params, { headers }).pipe(map(res => res));
 
    
  }

  generateTokenForService(serviceName: string) {
    const body = {
      serviceName : serviceName,
      lang : 'en'
    }
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('token', localStorage.getItem('usertoken') || '');
    return this.http.post(this.URL3 + `/generate/token/product`, body,{ headers }).pipe(map(res => res));;
  }

  logoutUser() {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('token', localStorage.getItem('usertoken') || '');
    return this.http.post(this.URL3 + `/logout`,{},{ headers }).pipe(map(res => res));;
  }
  
}
